import React from 'react';
import Icon from '../../../components/AppIcon';

const RegistrationProgress = ({ currentStep, totalSteps }) => {
  const steps = [
    { number: 1, label: 'Personal Info', icon: 'User' },
    { number: 2, label: 'Membership Plan', icon: 'CreditCard' },
    { number: 3, label: 'Payment', icon: 'DollarSign' },
    { number: 4, label: 'Waivers', icon: 'FileText' }
  ];

  return (
    <div className="w-full bg-card rounded-xl p-6 md:p-8 shadow-md border border-border">
      <div className="flex items-center justify-between">
        {steps?.map((step, index) => (
          <React.Fragment key={step?.number}>
            <div className="flex flex-col items-center gap-2 flex-1">
              <div
                className={`
                  w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center
                  transition-all duration-250
                  ${currentStep > step?.number
                    ? 'bg-success text-success-foreground'
                    : currentStep === step?.number
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground'
                  }
                `}
              >
                {currentStep > step?.number ? (
                  <Icon name="Check" size={24} />
                ) : (
                  <Icon name={step?.icon} size={24} />
                )}
              </div>
              <span
                className={`
                  text-xs md:text-sm font-medium text-center
                  ${currentStep >= step?.number ? 'text-foreground' : 'text-muted-foreground'}
                `}
              >
                {step?.label}
              </span>
            </div>
            {index < steps?.length - 1 && (
              <div className="flex-1 h-1 mx-2 md:mx-4 rounded-full bg-muted relative">
                <div
                  className={`
                    absolute inset-0 rounded-full transition-all duration-250
                    ${currentStep > step?.number ? 'bg-success' : 'bg-muted'}
                  `}
                  style={{
                    width: currentStep > step?.number ? '100%' : '0%'
                  }}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default RegistrationProgress;